"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItem = getItem;

function getItem(list, i) {
  return list[i] || null;
}
//# sourceMappingURL=getItem.js.map